const REQUEST_SEARCHES_REQUIRING_ATTENTION =
  'platfi-ui-app/DASHBOARD/REQUEST_SEARCHES_REQUIRING_ATTENTION';
const REQUEST_SEARCHES_REQUIRING_ATTENTION_SUCCESS =
  'platfi-ui-app/DASHBOARD/REQUEST_SEARCHES_REQUIRING_ATTENTION_SUCCESS';
const REQUEST_SEARCHES_REQUIRING_ATTENTION_FAILURE =
  'platfi-ui-app/DASHBOARD/REQUEST_SEARCHES_REQUIRING_ATTENTION_FAILURE';

export {
  REQUEST_SEARCHES_REQUIRING_ATTENTION,
  REQUEST_SEARCHES_REQUIRING_ATTENTION_SUCCESS,
  REQUEST_SEARCHES_REQUIRING_ATTENTION_FAILURE,
};
